import { RemoteUploadState } from '@lucidlink/sdk';
import { BrowserEntryType, filterBrowserEntriesByName, TableSortOrder, } from '@lucidlink/uicore';
import { PATH_SEPARATOR } from '#constants';
// The filesystem reports the root as an empty path, so a root child is just its name
export const joinEntryPath = (dirPath, name) => dirPath ? `${dirPath}${PATH_SEPARATOR}${name}` : name;
// The parent row is navigation, so it stays visible whatever the filter says
export const buildPickerEntries = ({ crumbs, currentDirContents, filter, }) => {
    const parentDirEntry = buildParentDirEntry(crumbs);
    const filteredContents = filterBrowserEntriesByName(currentDirContents ?? [], filter);
    return parentDirEntry
        ? [parentDirEntry, ...filteredContents]
        : filteredContents;
};
// Crumbs are a best-effort prefix of the trail, so the second-to-last one is the nearest known ancestor
export const buildParentDirEntry = (crumbs) => {
    const parentCrumb = crumbs?.at(-2);
    if (!parentCrumb) {
        return undefined;
    }
    return {
        id: parentCrumb.id,
        data: {
            isExternalFile: false,
            isParentDir: true,
            isVirtualDir: false,
            remoteUpload: RemoteUploadState.CLEAN,
        },
        name: parentCrumb.name,
        type: BrowserEntryType.DIR,
    };
};
// The parent row stays on top in both sort directions
export const createParentDirFirstSortConfig = (comparator) => ({
    [TableSortOrder.ascending]: (a, b) => compareParentDirFirst(a, b) || comparator(a, b),
    [TableSortOrder.descending]: (a, b) => compareParentDirFirst(a, b) || comparator(b, a),
});
const compareParentDirFirst = (a, b) => Number(Boolean(b.data.isParentDir)) - Number(Boolean(a.data.isParentDir));
